<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<div class="file-tree-container" [class.preview-hidden]="!showFilePreview">
  <div class="tree-panel" [class.collapsed]="isPanelCollapsed">
    <div class="tree-header">
      <div class="file-tree__search">
        @if (!isPanelCollapsed) {
          <lib-search
            [searchTerm]="searchTerm"
            [placeholder]="
              globalFileSearch
                ? 'Buscar archivos (Enter o espera)...'
                : 'Buscar carpetas...'
            "
            [loading]="isLoading || searchLoading"
            (searchChange)="onSearchChange($event)"
            (searchSubmit)="onSearchSubmit($event)"
            class="compact-search"
          >
          </lib-search>
        }
      </div>

      <button
        class="toggle-icon"
        (click)="togglePanelCollapse()"
        [attr.title]="isPanelCollapsed ? 'Expandir panel' : 'Colapsar panel'"
        type="button"
      >
        <lib-icon [name]="isPanelCollapsed ? 'ChevronRight' : 'ChevronLeft'" [size]="16"></lib-icon>
      </button>
    </div>

    @if (!isPanelCollapsed) {
      <div class="tree-scroll">
        @if ((isLoading || searchLoading) && !fileTree.length) {
          <div class="loading-state">
            <div class="spinner"></div>
            <span>{{ globalFileSearch ? 'Buscando archivos...' : 'Cargando...' }}</span>
          </div>
        }

        @if (filteredTree.length === 0 && !isLoading && !searchLoading) {
          <lib-empty
            [message]="
              flatSearchResults || globalFileSearch
                ? 'Sin archivos para esta busqueda'
                : 'No se encontraron carpetas'
            "
            [description]="
              globalFileSearch || flatSearchResults
                ? 'Escribe al menos 2 letras del nombre del archivo'
                : 'Intenta con otro termino de busqueda'
            "
          >
          </lib-empty>
        }

        @if (filteredTree.length > 0) {
          <div class="tree-nodes">
            @if (flatSearchResults) {
              <p class="tree-search-results-label">
                {{ filteredTree.length }} archivo(s)
              </p>
            }
            @for (node of filteredTree; track node.path) {
              @if (node.type === 'directory') {
                <ng-container
                  *ngTemplateOutlet="renderNode; context: { node: node, level: 0 }"
                ></ng-container>
              } @else if (node.type === 'file' && flatSearchResults) {
                <ng-container
                  *ngTemplateOutlet="renderFileNode; context: { node: node, level: 0 }"
                ></ng-container>
              }
            }
          </div>
        }
      </div>

      <div class="tree-footer">
        <div class="footer-info">
          <lib-icon name="Folder" [size]="14"></lib-icon>
          <span>{{ getTotalFoldersCount() }} carpetas</span>
        </div>
        <div class="footer-info">
          <lib-icon name="File" [size]="14"></lib-icon>
          <span>{{ getTotalFilesCount() }} archivos</span>
        </div>
      </div>
    }
  </div>

  @if (showFilePreview) {
    <div class="preview-panel">
      @if (virtualFolderPreview) {
        <div class="folder-content-wrapper">
          @if (virtualFolderPreview.showExitZip) {
            <div class="virtual-folder-toolbar">
              <p class="virtual-folder-toolbar__label">
                Contenido de <strong>{{ virtualFolderPreview.name }}</strong>
              </p>
              <button
                type="button"
                class="virtual-folder-toolbar__exit"
                (click)="exitVirtualFolder.emit()"
              >
                Salir del ZIP
              </button>
            </div>
          }
          @if (virtualFolderPreview.loading) {
            <div class="preview-empty">
              <lib-empty
                message="Cargando contenido del ZIP"
                description="Espere por favor..."
              />
            </div>
          } @else {
            <app-folder-actions
              [folderName]="virtualFolderPreview.name"
              [files]="virtualFolderPreview.files"
              [totalSize]="getVirtualFolderTotalSize(virtualFolderPreview.files)"
              [selectedFilePath]="selectedFilePath"
              [canAssign]="canAssign"
              [assignablePathPredicate]="assignablePathPredicate"
              (openFile)="onOpenFileFromFolder($event)"
              (downloadFile)="onDownloadFileFromFolder($event)"
              (assignFile)="onAssignFileFromFolder($event)"
            />
          }
        </div>
      } @else if (!selectedFolder) {
        <div class="preview-empty">
          <lib-empty
            message="Selecciona una carpeta"
            description="Elige una carpeta del arbol para ver su contenido"
          >
          </lib-empty>
        </div>
      } @else {
        <div class="folder-content-wrapper">
          <app-folder-actions
            [folderName]="selectedFolder.name"
            [files]="getFolderFiles(selectedFolder)"
            [totalSize]="getFolderTotalSize(selectedFolder)"
            [selectedFilePath]="selectedFilePath"
            [canAssign]="canAssign"
            [assignablePathPredicate]="assignablePathPredicate"
            (openFile)="onOpenFileFromFolder($event)"
            (downloadFile)="onDownloadFileFromFolder($event)"
            (assignFile)="onAssignFileFromFolder($event)"
          />
        </div>
      }
    </div>
  }
</div>

<ng-template #renderNode let-node="node" let-level="level">
  <div class="tree-node-wrapper">
    <div
      class="tree-node directory"
      [class.selected]="isNodeSelected(node)"
      [style.paddingLeft.px]="level * 16 + 8"
      (click)="handleFolderClick(node, $event)"
    >
      @if (hasChildren(node)) {
        <span class="expand-arrow">
          <lib-icon [name]="node.expanded ? 'ChevronDown' : 'ChevronRight'" [size]="12"></lib-icon>
        </span>
      } @else {
        <span class="expand-placeholder"></span>
      }

      <lib-icon
        class="tree-node-icon"
        [name]="node.expanded ? 'FolderOpen' : 'Folder'"
        [size]="16"
        aria-hidden="true"
      ></lib-icon>
      <span class="tree-node-name" [attr.title]="node.name">
        {{ node.name }}
      </span>
      <div
        class="node-badges"
        (click)="$event.stopPropagation()"
        aria-hidden="true"
      >
        @if (getSubfolderCount(node) > 0) {
          <span class="node-count folder-badge">{{ getSubfolderCount(node) }}</span>
        }
        @if (getDirectFileCount(node) > 0) {
          <span class="node-count file-badge">{{ getDirectFileCount(node) }}</span>
        }
      </div>
    </div>

    @if (node.expanded && node.children) {
      <div class="tree-children">
        @for (child of node.children; track child.path) {
          @if (child.type === 'directory') {
            <ng-container
              *ngTemplateOutlet="renderNode; context: { node: child, level: level + 1 }"
            ></ng-container>
          } @else if (child.type === 'file' && flatSearchResults) {
            <ng-container
              *ngTemplateOutlet="renderFileNode; context: { node: child, level: level + 1 }"
            ></ng-container>
          }
        }
      </div>
    }
  </div>
</ng-template>

<ng-template #renderFileNode let-node="node" let-level="level">
  <div
    class="tree-node file"
    [class.selected]="isFileSelected(node)"
    [style.paddingLeft.px]="level * 16 + 8"
    (click)="handleFileClick(node, $event)"
  >
    <span class="expand-placeholder"></span>
    <lib-icon class="tree-node-icon tree-node-icon--file" name="File" [size]="16" aria-hidden="true" />
    <span class="tree-node-name" [attr.title]="node.name">{{ node.name }}</span>
  </div>
</ng-template>
